import { Helper } from "../core/util/helper";
import { Dialog, DialogProps } from "../core/components/dialog";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DefaultProfilePictureGenerator } from "../core/util/defaultProfilePictureGenerator";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import React from "react";
import ReactDOM from "react-dom";

export default class ProfilePictureSelector extends React.Component<ProfilePictureSelectorProps, ProfilePictureSelectorState> {
    private id = kendo.guid();
    private ALLOWED_FILE_EXTENSIONS = [
        "jpg", "png", "jpeg", "gif"

    ];
    private defaultImage: string;
    constructor(props) {
        super(props)
        this.defaultImage = props.field.defaultImage || "circle-user";
        this.state = {
            userImageDocGuid: null,
            showCropButton: false
        };
        this.initApp();
    }

    private initApp = async () => {
        if (this.props.context.contextType == "resource" && !Helper.isNullOrEmpty(this.props.context.keyVal1)) {
            const result = await HTTPService.get<JsonResultClass>(`Resource/GetUserByRessNr?ressNr=${this.props.context.keyVal1}`);
            if (result.Code == 0 && Helper.hasValue(result.Data)) {
                this.setState({
                    userImageDocGuid: result.Data.Imagedocguid
                })
            }
        }
    }

    private setValue = (value: string) => {
        this.setState({ showCropButton: false }, () => {
            this.props.onChange(this.props.field, value);
        })
    }

    private onFileChange = async (event) => {
        const file = this.getFile(event.target.files);
        if (!Helper.hasValue(file)) {
            return;
        }
        await this.openCropDialog(file);
    }

    private getFile = (files: FileList) => {
        if (Helper.hasValue(files) && files.length > 0) {
            const file = files[0];
            const extension = file.name.split('.').pop();
            const isOk = this.ALLOWED_FILE_EXTENSIONS.findIndex((ext) => extension.toLowerCase() == ext.toLowerCase()) > -1;
            if (isOk) {
                return file;
            } else {
                NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.UserSettings.ProfilePicture.NotAImage"));
            }
        }
        return null;
    }

    private cropCurrentImage = async () => {
        const result = await fetch(`/Document/Download/${this.props.value}`);
        const blob = await result.blob();
        const file = new File([blob], 'tmp.png', blob)
        await this.openCropDialog(file);
    }

    private openCropDialog = async (file: File) => {
        const dialogResult = await OpenDialog(file);
        if (dialogResult.fileSelected) {

            const formData = new FormData();
            formData.append("file", file);
            formData.append("size", dialogResult.size.toString());
            formData.append("top", dialogResult.top.toString());
            formData.append("left", dialogResult.left.toString());
            const result = await HTTPService.post<JsonResultClass>("Document/UploadProfilePicture", formData)
            if (result.Code == 0) {
                this.setValue(result.Id);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private onImageLoad = (ev) => {
        const target = ev.target;
        if (target.height != target.width) {
            this.setState({ showCropButton: true })
        }

    }

    private renderImage = () => {
        let name = "";//
        let isGroup = false;
        switch (this.props.context.contextType.toLowerCase()) {
            case "resource":
                name = `${this.props.entity.Vorname} ${this.props.entity.Name}`;
                break;
            case "usersettings":
                name = this.props.entity.GeneralSettings.FullName;
                break;
            case "group":
                name = this.props.entity.Name;
                isGroup = true;
                break;
            default:
                console.log(this.props.context.contextType.toLowerCase())
                break;
        }


        const hasValue = !Helper.isNullOrEmpty(this.props.value);
        return (
            <div style={{ gridRow: "2/3", gridColumn: "1/2", display: "flex", justifyContent: "center" }} >
                <img style={{ maxWidth: "350px", maxHeight: "350px", display: hasValue ? "block" : "none" }} src={hasValue ? `${Config.baseUrl}Document/Download/${this.props.value}` : null} data-doc-id={this.props.value} onLoad={this.onImageLoad} />
                <div style={{ display: hasValue ? "none" : "block", fontSize: "350px" }} >
                    {DefaultProfilePictureGenerator.generateJSX({ name: name, background: isGroup ? "dark" : "bright", form: isGroup ? "square" : "circle", size: 350 })}
                    {/*<i style={{ height: "350px" }} className={`fa-thin fa-${this.defaultImage}`}></i>*/}
                </div>
            </div>
        );
    }

    private renderButtons = () => {
        if (!this.props.entity.RecordRight.CanWrite)
            return null;
        const buttons = [
            (
                <React.Fragment key={"profilePicture_edit"} >
                    <label htmlFor={this.id} data-role="button" >
                        <i className="fa-light fa-upload" style={{ fontSize: "1.2em", margin: "0px 10px 0 0" }} ></i>
                        {Helper.getTranslation(Helper.isNullOrEmpty(this.props.value) ? "Standard.Auswählen" : "WebSMS.ResourcePlanningScheduler.Contextmenü.Change")}
                    </label>
                </React.Fragment>
            )
        ];

        if (this.state.showCropButton) {
            buttons.push(
                <React.Fragment key={"profilePicture_crop"} >
                    <label onClick={this.cropCurrentImage} data-role="button">
                        <i className="fa-light fa-scissors" style={{ fontSize: "1.2em", margin: "0px 10px 0 0" }}></i>
                        {Helper.getTranslation("WebSMS.UserSettings.ProfilePicture.CropImage")}
                    </label>
                </React.Fragment>
            );
        }


        if (!Helper.isNullOrEmpty(this.props.value)) {
            buttons.push(
                <React.Fragment key={"profilePicture_delete"} >
                    <label onClick={() => { this.setValue(null) }} data-role="button">
                        <i className="fa-light fa-xmark" style={{ fontSize: "1.2em", margin: "0px 10px 0 0" }}></i>
                        {Helper.getTranslation("Standard.Entfernen")}
                    </label>
                </React.Fragment>
            );
        };

        if (!Helper.isNullOrEmpty(this.state.userImageDocGuid) && this.props.value != this.state.userImageDocGuid) {
            buttons.push(
                <React.Fragment key={"profilePicture_take_over"} >
                    <label onClick={() => { this.setValue(this.state.userImageDocGuid) }} data-role="button">
                        <i className='fal fa-user-circle'></i>
                        {Helper.getTranslation("WebSMS.UserSettings.ProfilePicture.TakeOver")}
                    </label>
                </React.Fragment>
            )
        }


        return <div style={{ display: "flex" }} >{buttons}</div>;
    }

    render() {
        return (
            <>
                <style>
                    {`  
                        .profile_picture_selector{
                            display: grid;
                            grid-template-columns: min-content;
                            grid-template-rows: 28px auto;
                            grid-gap: 15px;
                        }

                        .profile_picture_selector label[data-role="button"]{
                            border: 2px solid var(--secondary-color);
                            padding: 6px 12px;
                            cursor: pointer;
                            background-color: var(--primary-color);
                            color: white;
                            display: flex;
                            align-items: center;
                            width: fit-content;
                            margin-right: 10px;
                            height: 36px;   
                            border-radius: var(--border-radius);
                            white-space: nowrap;
                        }

                        .profile_picture_selector  label[data-role="button"]:hover{
                            background-color: var(--secondary-color);
                        }

                        .profile_picture_selector i {
                            margin-right: 10px
                        }

                        .profile_picture_selector > input[type="file"] {
                            display: none;
                        }
                    `}
                </style>
                <div className="profile_picture_selector">
                    {this.renderButtons()}
                    <input id={this.id} type='file' onChange={this.onFileChange} onClick={(event) => { (event.target as any).value = null }} accept={this.ALLOWED_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',')} />
                    {this.renderImage()}
                </div>
            </>
        );
    }
}

interface ProfilePictureSelectorProps extends BaseComponentProps {
    value: string;
    entity: any;
}
interface ProfilePictureSelectorState {
    userImageDocGuid: string;
    showCropButton: boolean;

}

const OpenDialog = (file: File) => {
    const MAX_HEIGHT = 350;
    return new Promise<ProfilePictureDialogResult>((resolve) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const onClose = () => {
            targetElement.remove();
        };

        const img = new Image();
        img.onload = () => {
            let height = img.height;
            let width = img.width;
            if (height > MAX_HEIGHT) {
                const ratio = width / height;
                height = MAX_HEIGHT;
                width = MAX_HEIGHT * ratio;
            }

            const onButtonClick = (result: ProfilePictureDialogResult) => {
                if (result.fileSelected && (img.height > MAX_HEIGHT)) {
                    const factor = img.height / MAX_HEIGHT;
                    result.left = Math.floor(result.left * factor);
                    result.size = Math.floor(result.size * factor);
                    result.top = Math.floor(result.top * factor);
                }
                resolve(result)
            }

            root.render(
                <>
                    <ProfilePictureDialog
                        file={file}
                        height={height}
                        width={width}
                        onClose={onClose}
                        onButtonClick={onButtonClick}
                    />
                </>
            );
        }
        img.src = URL.createObjectURL(file);
    });
}

interface ProfilePictureDialogResult {
    fileSelected: boolean;
    file: File;
    size: number;
    top: number;
    left: number;
}

class ProfilePictureDialog extends React.Component<ProfilePictureDialogProps, ProfilePictureDialogState>{
    private SIZE_CORNER_BOX = 6;
    private MIN_SIZE = this.SIZE_CORNER_BOX * 4;
    private MAX_SIZE: number;

    private imgWrapper: HTMLElement;

    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.UserSettings.ProfilePicture.Crop"),
        actions: [
            {
                action: () => {
                    this.props.onButtonClick({
                        fileSelected: false,
                        file: null,
                        left: null,
                        size: null,
                        top: null
                    });
                },
                label: Helper.getTranslation("Standard.CloseBtn"),
                primary: false
            },
            {
                action: () => {
                    const [left, top] = this.state.crop.get();
                    this.props.onButtonClick({
                        fileSelected: true,
                        file: this.props.file,
                        left: left,
                        size: this.state.size,
                        top: top
                    });
                },
                label: Helper.getTranslation("Standard.Select"),
                primary: true
            }
        ],
        afterClose: () => {
            this.disableEditing();
        },
        open: true
    };
    private resize: (ev) => void;
    constructor(props: ProfilePictureDialogProps) {
        super(props);
        this.MAX_SIZE = Math.min(props.height, props.width);
        this.state = {
            crop: this.getStartPos(),
            startCrop: Position.Origin(),
            startPos: Position.Origin(),
            mousePos: Position.Origin(),
            size: Math.floor(this.MAX_SIZE),
            startSize: Math.floor(this.MAX_SIZE)
        }
    }

    private getStartPos = () => {
        const top = (this.props.height / 2) - (this.MAX_SIZE / 2);
        const left = (this.props.width / 2) - (this.MAX_SIZE / 2);
        return Position.RawValues(left, top);
    }

    //Moving
    private enableMoving = (e) => {
        this.setState({ mousePos: Position.Event(e), startPos: this.state.crop.clone() }, () => {
            window.addEventListener('mousemove', this.move, true);
        });
    }

    private move = (e) => {
        const currentPos = Position.Event(e);
        const mouseDiff = Position.Substract(currentPos, this.state.mousePos);
        let [left, top] = Position.Add(this.state.startPos, mouseDiff).get();
        top = this.checkValue(top, this.props.height)
        left = this.checkValue(left, this.props.width)
        this.setState({ crop: Position.RawValues(left, top) })
    }

    private checkValue = (value: number, maxValue: number) => {
        if (value < 0)
            value = 0;
        if ((value + this.state.size) > maxValue)
            value = maxValue - this.state.size;
        return value;
    }

    private disableMoving = () => {
        window.removeEventListener('mousemove', this.move, true);
    }

    private setResizeFunction = (cornerPosition: CornerPosition) => {
        const getNewSize = (delta: PositionDelta) => {
            let value = this.state.startSize + delta.min();
            value = Math.max(value, this.MIN_SIZE);
            value = Math.min(value, this.MAX_SIZE);
            return value;
        }

        const ignoreResizing = (ev) => {
            const { left, top } = this.imgWrapper.getBoundingClientRect();
            const clientX: number = ev.clientX;
            const clientY: number = ev.clientY;

            const right = left + this.props.width;
            const bottom = top + this.props.height;

            if ((left <= clientX) && (clientX <= right)) {
                return false;
            }
            if ((top <= clientY) && (clientY <= bottom)) {
                return false;
            }
            return true;
        }

        this.resize = (ev) => {
            ev.stopPropagation();
            if (ignoreResizing(ev)) {
                return;
            }
            const currentPos = Position.Event(ev);
            const diff = Position.Substract(currentPos, this.state.startPos);
            let [left, top] = this.state.crop.get();

            const bottom = this.props.height - top - this.state.size;
            const right = this.props.width - left - this.state.size;

            let newSize = this.state.size;
            let newTop = this.state.startCrop.getTop();
            let newLeft = this.state.startCrop.getLeft();
            switch (cornerPosition) {
                case "top-left":
                    newSize = getNewSize(PositionDelta.RawValues((-1) * diff.getDeltaLeft(), (-1) * diff.getDeltaTop()));
                    newTop = this.props.height - bottom - newSize;
                    newLeft = this.props.width - right - newSize;
                    break;
                case "top-right":
                    newSize = getNewSize(PositionDelta.RawValues(diff.getDeltaLeft(), (-1) * (diff.getDeltaTop())));
                    newTop = this.props.height - bottom - newSize;
                    break;
                case "bottom-right":
                    newSize = getNewSize(diff);
                    break;
                case "bottom-left":
                    newSize = getNewSize(PositionDelta.RawValues((-1) * (diff.getDeltaLeft()), diff.getDeltaTop()));
                    newLeft = this.props.width - right - newSize;
                    break;
            }

            if ((newTop + newSize) > this.props.height)
                newTop = this.props.height - newSize;

            if ((newLeft + newSize) > this.props.width)
                newLeft = this.props.width - newSize;

            this.setState({ size: newSize, crop: Position.RawValues(newLeft, newTop) })
        };
    }

    private disableResizing = () => {
        if (Helper.hasValue(this.resize)) {
            window.removeEventListener('mousemove', this.resize, true);
            this.resize = null;
        }
    }

    private renderResizingBox = (cornerPosition: CornerPosition) => {
        const enableSizing = (ev) => {
            ev.stopPropagation();
            this.setResizeFunction(cornerPosition)
            this.setState({ startPos: Position.Event(ev), startSize: this.state.size, startCrop: this.state.crop.clone() }, () => {
                window.addEventListener('mousemove', this.resize, true);
            })
        }
        const style: React.CSSProperties = {
            backgroundColor: "#000000",
            border: "1px solid #ffffff",
            width: "10px",
            height: "10px",
            position: "absolute",
            fontSize: "1px",
            cursor: cornerPosition == "top-left" || cornerPosition == "bottom-right" ? "nw-resize" : "ne-resize",
            zIndex: 10
        };

        const pos = `-${this.SIZE_CORNER_BOX}px`;
        if (cornerPosition.includes("top")) {
            style.top = pos;
        }

        if (cornerPosition.includes("bottom")) {
            style.bottom = pos;
        }

        if (cornerPosition.includes("left")) {
            style.left = pos;
        }

        if (cornerPosition.includes("right")) {
            style.right = pos;
        }

        return <div data-sizing-corner={cornerPosition} style={style} onMouseDown={enableSizing} onDrag={this.disableResizing} ></div>;
    }

    private disableEditing = () => {
        window.addEventListener('mouseup', this.disableMoving, false);
        window.addEventListener('mouseup', this.disableResizing, false);
    }


    componentDidMount() {
        this.disableEditing()
    }

    render() {
        const crop = this.state.crop;
        const [left, top] = crop.get();
        return (
            <Dialog {...this.dialogProps}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ height: `${this.props.height}px`, width: `${this.props.width}px`, display: "grid", gridTemplateRows: `${top}px ${this.state.size}px 1fr`, gridTemplateColumns: `${left}px ${this.state.size}px 1fr` }} onMouseLeave={() => { this.disableEditing() }}>
                        <img ref={(ref) => { this.imgWrapper = ref }} src={URL.createObjectURL(this.props.file)} style={{ height: `${this.props.height}px`, width: `${this.props.width}px`, gridRow: "1/4", gridColumn: "1/4" }} />
                        <div style={{ gridRow: `2/3`, gridColumn: `2/3`, border: "1px solid black", cursor: "move", zIndex: 5 }}></div>
                        <div style={{ gridRow: `2/3`, gridColumn: `2/3`, border: "1px dashed white", cursor: "move", position: "relative", zIndex: 5 }} onMouseDown={this.enableMoving} onDrag={this.disableEditing}>
                            {this.renderResizingBox("top-left")}
                            {this.renderResizingBox("top-right")}
                            {this.renderResizingBox("bottom-right")}
                            {this.renderResizingBox("bottom-left")}
                        </div>
                        <div style={{ gridRow: `1/2`, gridColumn: `1/4`, backgroundColor: "black", opacity: 0.5 }}></div>
                        <div style={{ gridRow: `3/4`, gridColumn: `1/4`, backgroundColor: "black", opacity: 0.5 }}></div>
                        <div style={{ gridRow: `2/3`, gridColumn: `1/2`, backgroundColor: "black", opacity: 0.5 }}></div>
                        <div style={{ gridRow: `2/3`, gridColumn: `3/4`, backgroundColor: "black", opacity: 0.5 }}></div>
                    </div>
                </div>
            </Dialog>
        );
    }
}

interface ProfilePictureDialogProps {
    file: File;
    onClose: () => void;
    onButtonClick: (result: ProfilePictureDialogResult) => void;
    height: number;
    width: number;
}

interface ProfilePictureDialogState {
    crop: Position;
    startCrop: Position;

    startPos: Position;
    mousePos: Position;

    size: number;
    startSize: number;
}


type LeftRight = 'left' | 'right';
type TopBottom = 'top' | 'bottom';
type CornerPosition = `${TopBottom}-${LeftRight}`


interface IPosition {
    get: () => number[];
    print: () => void;
}

class Position implements IPosition {
    static Origin() {
        return new Position(0, 0);
    }

    static RawValues(left: number, top: number) {
        return new Position(left, top);
    }

    static Event(ev) {
        const clientX: number = ev.clientX;
        const clientY: number = ev.clientY;
        return new Position(clientX, clientY);
    }


    private _left: number;
    private _top: number;

    private constructor(left: number, top: number) {
        this._left = Math.floor(left > 0 ? left : 0);
        this._top = Math.floor(top > 0 ? top : 0);
    }


    getTop = () => {
        return this._top;
    }

    getLeft = () => {
        return this._left;
    }

    get = () => {
        return [this._left, this._top];
    }

    clone = () => {
        return new Position(this._left, this._top);
    }

    print = () => {
        console.info(`Left: ${this._left}; Top: ${this._top}`)
    }

    static Substract = (pos1: Position, pos2: Position) => {
        const [l1, t1] = pos1.get();
        const [l2, t2] = pos2.get();
        return PositionDelta.RawValues(l1 - l2, t1 - t2);
    }

    static Add = (pos1: Position, pos2: IPosition) => {
        const [l1, t1] = pos1.get();
        const [l2, t2] = pos2.get();
        return new Position(l1 + l2, t1 + t2);
    }
}

class PositionDelta implements IPosition {
    static NoDelta() {
        return new PositionDelta(0, 0);
    }

    static RawValues(deltaLeft: number, deltaTop: number) {
        return new PositionDelta(deltaLeft, deltaTop);
    }

    private _deltaLeft: number;
    private _deltaTop: number;

    private constructor(deltaLeft: number, deltaTop: number) {
        this._deltaLeft = Math.floor(deltaLeft);
        this._deltaTop = Math.floor(deltaTop);
    }

    setDeltaLeft = (value: number) => {
        this._deltaLeft = value;
    }

    getDeltaLeft = () => {
        return this._deltaLeft;
    }

    setDeltaTop = (value: number) => {
        this._deltaTop = value;
    }

    getDeltaTop = () => {
        return this._deltaTop;
    }

    get = () => {
        return [this._deltaLeft, this._deltaTop];
    }

    print = () => {
        console.info(`Delta left: ${this._deltaLeft}; Delta top: ${this._deltaTop}`)
    }

    min = () => {
        return Math.min(this._deltaLeft, this._deltaTop);
    }


}

